module.exports = __webpack_public_path__ + "img/circles3.7e0a68d6.svg";